import SearchInput from "components/input/SearchInput";

interface FeedbackFilterBarProps {
  searchValue: string | null;
  onSearchChange: (value: string | null) => void;
}

export const FeedbackFilterBar = ({ searchValue, onSearchChange }: FeedbackFilterBarProps) => {
  return (
    <div className="text-color-base bg-color-base mb-4 flex flex-col items-start gap-4 rounded-md border border-slate-200 p-4 dark:border-slate-800 sm:flex-row sm:items-center">
      <div className="w-full sm:w-96">
        <SearchInput onSearch={(value) => onSearchChange(value)} term={searchValue} />
      </div>
    </div>
  );
};
